/**
 * Build-time feature flags.
 *
 * ENABLE_REQUEST_AGENT — the "Request New Agent" entry points open the builder's
 * new-agent scoping flow. Hidden for launch (2026-07-22) until the repo-intake
 * funnel is customer-ready; re-enable with REACT_APP_ENABLE_NEW_AGENT=true.
 */
export const ENABLE_REQUEST_AGENT =
  process.env.REACT_APP_ENABLE_NEW_AGENT === 'true';
